import {
    mapState,
    mapActions,
} from 'vuex'
import viewName from '../constant'
import {
    getLoginInfo
} from '../../utils/loginInfo'
import {
    Swipe,
    SwipeItem,
    Button,
    Sticky
} from 'vant'
import StoreCard from '@/components/storeCard/storeCard.tpl.vue'
import QualityImg from '@/components/qualityImg/qualityImg.vue'
import onlineCustomerDialog from '@/components/onlineCustomerDialog/onlineCustomerDialog.vue'
import defaultImg from '../../assets/images/common/defaultImg.png'
// import { wxConfig } from '@/utils/wxsdk'
import * as SESSION from '../../utils/session'
import * as STORAGE from '../../utils/storage'
import _ from 'lodash'
// import { getLocalConfig } from 'utils/storage'
import {
    configWeixin,
    wxShare,
    // wxConfig
} from '@/utils/wxsdk'
// import { toQueryObject } from '../../utils/util'
// import { getAccessToken } from 'utils/wxsdk'
export default {
    inject: ['showLoading', 'hideLoading'],
    name: viewName.home,
    components: {
        Swipe,
        SwipeItem,
        Button,
        StoreCard,
        Sticky,
        QualityImg,
        'online-Dialog': onlineCustomerDialog
    },
    data () {
        return {
            pageShow: false,
            title: '',
            id: '',
            userInfo: getLoginInfo(),
            current: 0,
            recommendGoods: '',
            share: {},
            store: {},
            usersRecords: {},
            purchaseList: [],
            videoHtml: '',
            backstageImgs: {},
            images: {},
            keyName: 'MARKETING_CONFIG',
            shareHint: false,
            shareWxHint: false,
            copyMessage: '',
            defaultImg: defaultImg,
            isFirst: true
        }
    },
    computed: {
        ...mapState({
            appInfo: ({
                appInfo
            }) => appInfo,
            token: ({
                appInfo
            }) => appInfo.token,
            iswx: ({
                appInfo
            }) => appInfo.isWeixin
        }),
    },
    async created () {
        // 通过code获取用户信息
        if (this.iswx) {
            // this.getWxUserInfo(this.$route.query.code || '').then(_ => {
            //     const _thisPath = this.$route.path
            //     let _thisQuery = this.$route.query
            //     _thisQuery['code'] && delete _thisQuery['code'] && this.$router.replace(`${_thisPath}?${toQueryObject(_thisQuery)}`)
            // })
            configWeixin()
        }
        let id = ''
        id = this.$route.query.id
        if (id) {
            // 存储marketing_id
            let marketingConfig = {
                marketing_id: id
            }
            marketingConfig = Object.assign({}, marketingConfig)
            SESSION.setLocalConfig(this.keyName, marketingConfig)
            // end
            this.id = id
        } else {
            id = SESSION.getLocalConfig(this.keyName).marketing_id
            this.id = id || ''
        }
        // 获取用户是否第一次打开页面然后存储到Local Storage
        // key:ISFIRST,val:1 [1:第一次，2:不是第一次] 不需要清除缓存ISFIRST
        if (STORAGE.getLocalConfig('ISFIRST') && STORAGE.getLocalConfig('ISFIRST') === 2) {
            this.isFirst = false
        } else {
            this.isFirst = true
            STORAGE.setLocalConfig('ISFIRST', 2)
        }
    },
    activated () {},
    mounted () {
        let marketingConfig = {
            marketing_id: ''
        }
        this.showLoading()
        this.getMarkeTingInfo(this.id)
            .then(res => {
                if (!res.errmsg) {
                    this.recommendGoods = res.recommend_goods
                    this.share = res.share
                    this.store = res.store
                    this.usersRecords = res.users_records
                    this.videoHtml = res.video_html
                    this.backstageImgs = res.backstage_imgs
                    this.title = res.title
                    this.id = res.marketing_id
                    // 重新存储marketing_id
                    marketingConfig.marketing_id = this.id
                    marketingConfig = Object.assign({}, marketingConfig)
                    SESSION.setLocalConfig(this.keyName, marketingConfig)
                    // end
                    // 更新页面url 用在用户复制连接
                    this.$router.replace({
                        path: '/',
                        query: {
                            id: this.id
                        }
                    })
                    this.copyMessage = location.href
                    this.setTitle()
                    this.chunk()
                    this.getMarketingInfoImgs(this.id)
                        .then(res => {
                            this.images = res
                            this.pageShow = true
                        })
                        .catch(res => {})
                    this.configWxShare(res.share)
                } else {
                    this.$dialog
                        .alert({
                            message: '当前活动已过期'
                        })
                        .then(() => {
                            this.$router.replace({
                                path: '/pageNotFound'
                            })
                        })
                }
                this.hideLoading()
            }).catch(res => {
                this.hideLoading()
                this.$dialog
                    .alert({
                        message: '当前活动已过期'
                    })
                    .then(() => {
                        this.$router.replace({
                            path: '/pageNotFound'
                        })
                    })
                // 获取内容报错时删除存储内容
                SESSION.removeLocalConfig(this.keyName)
            })
    },
    methods: {
        ...mapActions([
            'checkIsWeixin',
            'getMarkeTingInfo',
            'getMarketingInfoImgs',
            'verifyUserInfo',
            'getWxUserInfo'
        ]),
        setTitle () {
            this.$emit('setHeader', {
                title: this.title || '首页',
                showLeft: false,
                hasSearch: false,
                showRight: false
            })
        },

        goToGoodsDetail: _.throttle(function () {
            this.verifyUserInfo().then(_ => {
                this.navigationToGoodsDetail()
            })
        }, 300),
        navigationToGoodsDetail () {
            this.$router.push({
                name: 'goodsDetail',
                query: {
                    marketing_id: this.id
                }
            })
        },
        // 头部图册切换
        onChange (index) {
            this.current = index
        },
        // 跳转图集
        goToImages () {
            this.$router.push({
                path: '/photoReports',
                query: {
                    id: this.id
                }
            })
        },
        // 整理用户下单数据
        chunk () {
            this.purchaseList = _.chunk(this.usersRecords.purchase, 3)
        },
        // 分享
        shareFn () {
            this.iswx ? (this.shareWxHint = true) : (this.shareHint = true)
            if (this.iswx) {
                wxShare({
                    link: location.href,
                    ...this.share
                })
            }
        },
        onCopy (e) {
            this.$toast('复制成功')
        },
        imgLink (e) {
            const linkType = e
            if (linkType === 1) {
                if (this.backstageImgs.moduleA_link) {
                    location.href = this.backstageImgs.moduleA_link
                }
            } else {
                if (this.backstageImgs.moduleB_link) {
                    location.href = this.backstageImgs.moduleB_link
                }
            }
        },
        // 关闭进入图册提示
        isFirstShow () {
            this.isFirst = !this.isFirst
        },
        configWxShare (detail) {
            if (this.iswx) {
                wxShare({
                    link: location.href,
                    ...detail
                })
            }
        }
    },
    // beforeRouteLeave (to, from, next) {
    //     // 设置下一个路由的 meta
    //     to.meta.keepAlive = false // C 跳转到 A 时让 A 不缓存，即刷新
    //     // to.meta.title = '确认订单'
    //     next()
    // }
}
